import { useEffect, useMemo, useState } from 'react';
import { hrApi } from '@/api/hr.api';
import { SearchableSelect } from '@/components/ui/SearchableSelect';
import type { SelectOption } from '@/components/ui/Select';
import type { HrExpenseType } from '@/types/hr';
import { showApiError } from '@/utils/apiError';

export function ExpenseTypeSelect({
  label = 'Expense type',
  value = '',
  onChange,
  placeholder = 'Select expense type',
  className,
  required,
}: {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
  required?: boolean;
}) {
  const [types, setTypes] = useState<HrExpenseType[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    hrApi
      .listExpenseTypes()
      .then(setTypes)
      .catch((err) => showApiError(err, 'Failed to load expense types'))
      .finally(() => setLoading(false));
  }, []);

  const options: SelectOption[] = useMemo(
    () =>
      types
        .filter((type) => type.active !== false)
        .map((type) => ({
          value: type.code,
          label: `${type.name} (${type.code})`,
        })),
    [types],
  );

  return (
    <SearchableSelect
      className={className}
      label={label}
      required={required}
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      loading={loading}
      searchPlaceholder="Search expense types…"
      emptyMessage="No expense types — configure them in HR Master data"
    />
  );
}
